/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_IapInputs */

const en_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

const ar_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشتريات داخل التطبيق`)
};

const bn_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

const de_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

const es_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

const fr_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

const pt_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

const zh_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

const tr_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

const ru_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

const pl_svchip_iap = /** @type {(inputs: Svchip_IapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IAP`)
};

/**
* | output |
* | --- |
* | "IAP" |
*
* @param {Svchip_IapInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_iap = /** @type {((inputs?: Svchip_IapInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_IapInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_iap(inputs)
	if (locale === "bn") return bn_svchip_iap(inputs)
	if (locale === "de") return de_svchip_iap(inputs)
	if (locale === "es") return es_svchip_iap(inputs)
	if (locale === "fr") return fr_svchip_iap(inputs)
	if (locale === "pt") return pt_svchip_iap(inputs)
	if (locale === "zh") return zh_svchip_iap(inputs)
	if (locale === "tr") return tr_svchip_iap(inputs)
	if (locale === "ru") return ru_svchip_iap(inputs)
	if (locale === "pl") return pl_svchip_iap(inputs)
	return en_svchip_iap(inputs)
});